module.exports = __webpack_public_path__ + "static/media/3DPPA32.15d14c0a.jpg";